(()=>{
  function init(root){
    if(root.dataset.initialized)return;
    const dialog=root.querySelector('dialog');
    if(!dialog||!dialog.showModal)return;
    root.dataset.initialized='true';
    const links=[...root.querySelectorAll('[data-runway-image]')];
    const image=dialog.querySelector('[data-viewer-image]');
    const count=dialog.querySelector('[data-viewer-count]');
    let index=0,opener=null,oldOverflow='',touchX=null;
    function show(next){
      index=(next+links.length)%links.length;
      const link=links[index],thumbnail=link.querySelector('img');
      image.src=link.href;image.alt=thumbnail.alt;
      count.textContent=`${index+1} / ${links.length}`;
    }
    links.forEach((link,i)=>link.addEventListener('click',event=>{
      if(event.ctrlKey||event.metaKey||event.shiftKey||event.altKey)return;
      event.preventDefault();opener=link;show(i);
      oldOverflow=document.documentElement.style.overflow;
      dialog.showModal();document.documentElement.style.overflow='hidden';
    }));
    dialog.querySelector('[data-viewer-close]').addEventListener('click',()=>dialog.close());
    dialog.querySelector('[data-viewer-prev]').addEventListener('click',()=>show(index-1));
    dialog.querySelector('[data-viewer-next]').addEventListener('click',()=>show(index+1));
    dialog.addEventListener('keydown',event=>{
      if(event.key==='ArrowLeft'){event.preventDefault();show(index-1);}
      if(event.key==='ArrowRight'){event.preventDefault();show(index+1);}
    });
    dialog.addEventListener('close',()=>{document.documentElement.style.overflow=oldOverflow;opener?.focus({preventScroll:true});});
    const frame=dialog.querySelector('.maison-runway__frame');
    frame.addEventListener('touchstart',event=>{touchX=event.touches.length===1?event.touches[0].clientX:null;},{passive:true});
    frame.addEventListener('touchend',event=>{if(touchX===null)return;const delta=event.changedTouches[0].clientX-touchX;touchX=null;if(Math.abs(delta)>70)show(index+(delta<0?1:-1));},{passive:true});
  }
  function scan(){document.querySelectorAll('[data-maison-runway]').forEach(init);}
  scan();document.addEventListener('shopify:section:load',scan);
})();
